module.exports = __webpack_public_path__ + "static/media/Vela - Dk Gold_White.70d797dc.jpg";